import { PaywallModal, ModalKey } from 'approot/shared/modal/modal.constants';

export function chooseUnauthorisedPaywall(props: {
  isAlreadySignedInOnce: boolean;
  isSignedIn: boolean;
  isAccountExpired: boolean;
  isSchoolAdmin: boolean;
  isSchoolTeacher: boolean;
}): PaywallModal {
  if (!props.isSignedIn && props.isAlreadySignedInOnce) {
    return ModalKey.SIGNIN;
  }
  if (!props.isSignedIn) {
    return ModalKey.JOIN;
  }
  if (props.isAccountExpired) {
    return ModalKey.INACTIVE_ACCOUNT;
  }
  if (props.isSchoolAdmin && !props.isSchoolTeacher) {
    return ModalKey.ADMIN;
  }
  if (props.isSchoolTeacher) {
    return ModalKey.NONE;
  }
  return ModalKey.DENIED;
}
